const wrapperClasses =
  "flex items-start gap-2.5 mb-3 py-2.5 px-3.5 " +
  "bg-warning-surface border border-warning-light rounded-md " +
  "text-[calc(var(--spacing)*3.25)] leading-normal text-warning";

const iconClasses = "fa fa-exclamation-triangle shrink-0 mt-0.5 text-sm text-warning";

const headingClasses = "block mb-1 text-[calc(var(--spacing)*3.25)]";

const messageClasses = "m-0! mb-1! last:mb-0!";

const DemandStudioSectionWarning = ({ title, messages = [] }) => (
  <div className={wrapperClasses}>
    <i className={iconClasses} />
    <div>
      <strong className={headingClasses}>{title}</strong>
      {messages.map((message, index) => (
        <p key={index} className={messageClasses}>{message}</p>
      ))}
    </div>
  </div>
);

export default DemandStudioSectionWarning;
